import axios from "axios";
import Cookies from "js-cookie";
import { IDOM_API_URL, PRODUCT_SLUG, TOKEN_NAME } from "../config";

// Central account APIs are separate from the Notes service.
export const idomApi = axios.create({
  baseURL: `${IDOM_API_URL.replace(/\/+$/, "")}/`,
});

const authHeaders = () => ({
  Authorization: `Bearer ${Cookies.get(TOKEN_NAME) || ""}`,
});

export const fetchUserCompanies = async ({ companyId, search, page = 0, signal }) => {
  const response = await idomApi.get("user/companies_list", {
    params: {
      page_number: page,
      limit: 10,
      ...(companyId ? { company_id: companyId } : {}),
      ...(search ? { search_query: search } : {}),
    },
    headers: {
      ...authHeaders(),
      "Cache-Control": "no-store",
      Pragma: "no-cache",
      Expires: "0",
    },
    signal,
  });
  return response.data;
};

export const setDefaultCompany = async (companyId) => {
  const data = new FormData();
  data.append("company_id", String(companyId));
  data.append("product_slug", PRODUCT_SLUG);
  const response = await idomApi.post("user/set_default_company", data, {
    headers: authHeaders(),
  });
  return response.data;
};

export const requestError = (error, fallback) => {
  const message = error?.response?.data?.message;
  return typeof message === "string" ? message : fallback;
};
